import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { Modal, Button } from "react-bootstrap";
import { Printer } from "react-feather";
import RefillPrintPreview from "./RefillPrintPreview";
import { useLazyGetGeneralManagerSignatureQuery } from "../../../masters/employees/employeesApi";
import { blobToDataUrl } from "../../../stock/lpo/buildLpoPrintProps";

/** Preview + print for an approved refill request - same popup pattern as VoucherPrintModal. */
const RefillPrintModal = ({ show, onClose, refill }) => {
  const [fetchGeneralManagerSignature] = useLazyGetGeneralManagerSignatureQuery();
  const [signatureImageUrl, setSignatureImageUrl] = useState(null);

  useEffect(() => {
    if (!show) return undefined;
    let cancelled = false;
    fetchGeneralManagerSignature()
      .unwrap()
      .then(blobToDataUrl)
      .then((url) => { if (!cancelled) setSignatureImageUrl(url); })
      .catch(() => { if (!cancelled) setSignatureImageUrl(null); });
    return () => { cancelled = true; };
  }, [show, fetchGeneralManagerSignature]);

  const handlePrint = () => {
    const bodyHtml = ReactDOMServer.renderToStaticMarkup(
      <RefillPrintPreview refill={refill} signatureImageUrl={signatureImageUrl} />
    );
    const win = window.open("", "_blank", "width=900,height=1000");
    if (!win) return;
    win.document.write(
      `<html><head><title>Petty Cash Refill - ${refill?.requestNumber || ""}</title>` +
        `<style>@page { size: A4; margin: 10mm; } html,body { margin:0; padding:0; } body { width: 190mm; }</style>` +
        `</head>` +
        `<body onload="window.print();window.close();">${bodyHtml}</body></html>`
    );
    win.document.close();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title className="h5">
          Refill {refill?.requestNumber}
          <span className="text-muted ms-2 fs-6">preview</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#e9ecef" }}>
        <div style={{ background: "#fff", boxShadow: "0 1px 6px rgba(0,0,0,.2)" }}>
          <RefillPrintPreview refill={refill} signatureImageUrl={signatureImageUrl} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handlePrint} className="d-inline-flex align-items-center gap-2">
          <Printer size={16} /> Print
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RefillPrintModal;
